'use strict';exports.__esModule = true;exports.sendPropertiesAnalytics = exports.sendReferralId = exports.closeChartOfViews = exports.openChartOfViews = exports.loadSinglePropertyAnalytics = exports.loadPropertiesAnalytics = undefined;var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');

var _axiosConfig = require('../../helpers/axiosConfig');var _axiosConfig2 = _interopRequireDefault(_axiosConfig);
var _formatApiError = require('../../helpers/formatApiError');var _formatApiError2 = _interopRequireDefault(_formatApiError);
var _constants = require('../../constants');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

promise = _reduxLoop.Effects.promise;

var loadPropertiesAnalytics = (0, _reduxAct.createAction)('/LOAD_PROPERTIES_ANALYTICS');
var loadPropertiesAnalyticsSuccess = (0, _reduxAct.createAction)('/LOAD_PROPERTIES_ANALYTICS_SUCCESS');
var loadPropertiesAnalyticsFail = (0, _reduxAct.createAction)('/LOAD_PROPERTIES_ANALYTICS_FAIL');

var loadPropertiesAnalyticsFavoritesSuccess = (0, _reduxAct.createAction)('/LOAD_PROPERTIES_FAVOURITES_SUCCESS');
var loadPropertiesAnalyticsFavoritesFail = (0, _reduxAct.createAction)('/LOAD_PROPERTIES_FAVOURITES_FAIL');

var loadPropertiesAnalyticsShowNumberSuccess = (0, _reduxAct.createAction)('/LOAD_PROPERTIES_SHOW_NUMBER_SUCCESS');
var loadPropertiesAnalyticsShowNumberFail = (0, _reduxAct.createAction)('/LOAD_PROPERTIES_SHOW_NUMBER_FAIL');

var loadSinglePropertyAnalytics = (0, _reduxAct.createAction)('/LOAD_SINGLE_PROPERTY_ANALYTICS');
var loadSinglePropertyAnalyticsSuccess = (0, _reduxAct.createAction)('/LOAD_SINGLE_PROPERTY_ANALYTICS_SUCCESS');
var loadSinglePropertyAnalyticsFail = (0, _reduxAct.createAction)('/LOAD_SINGLE_PROPERTY_ANALYTICS_FAIL');
var openChartOfViews = (0, _reduxAct.createAction)('/OPEN_CHART_OF_VIEWS');
var closeChartOfViews = (0, _reduxAct.createAction)('/CLOSE_CHART_OF_VIEWS');

var sendReferralId = (0, _reduxAct.createAction)('/REFERRAL_LINK');
var sendUserAnalyticsSuccess = (0, _reduxAct.createAction)('/SEND_USER_ANALYTIC_SUCCESS');
var sendUserAnalyticsFail = (0, _reduxAct.createAction)('/SEND_USER_ANALYTIC_FAIL');

var sendPropertiesAnalytics = (0, _reduxAct.createAction)('/SEND_PROPERTIES_ANALYTIC');
var sendPropertiesAnalyticsSuccess = (0, _reduxAct.createAction)('/SEND_PROPERTIES_ANALYTIC_SUCCESS');
var sendPropertiesAnalyticsFail = (0, _reduxAct.createAction)('/SEND_PROPERTIES_ANALYTIC_FAIL');

var initialState = {
  loaded: false,
  loading: false };


var fetchLoad = function fetchLoad(params) {
  switch (params.action) {
    case _constants.analyticsEventAction.FAVOURITES:return _axiosConfig2.default.get('/properties', { params: params }).
      then(loadPropertiesAnalyticsFavoritesSuccess, loadPropertiesAnalyticsFavoritesFail);

    case _constants.analyticsEventAction.SHOW_NUMBER:return _axiosConfig2.default.get('/properties', { params: params }).
      then(loadPropertiesAnalyticsShowNumberSuccess, loadPropertiesAnalyticsShowNumberFail);

    default:return _axiosConfig2.default.get('/properties', { params: params }).
      then(loadPropertiesAnalyticsSuccess, loadPropertiesAnalyticsFail);}

};

var handleLoadPropertiesAnalytics = function handleLoadPropertiesAnalytics(state, params) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true,
    error: null }),
  promise(fetchLoad, params));};

var handleLoadPropertiesAnalyticsFavoritesSuccess = function handleLoadPropertiesAnalyticsFavoritesSuccess(state, action) {return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    favoritesData: action.data });};


var handleLoadPropertiesAnalyticsFavoritesFail = function handleLoadPropertiesAnalyticsFavoritesFail(state, action) {
  var error = (0, _formatApiError2.default)(action, 'Error while loading property analytics');

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    data: null,
    error: error });

};

var handleLoadPropertiesAnalyticsShowNumberSuccess = function handleLoadPropertiesAnalyticsShowNumberSuccess(state, action) {return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    ShowNumberData: action.data });};


var handleLoadPropertiesAnalyticsShowNumberFail = function handleLoadPropertiesAnalyticsShowNumberFail(state, action) {
  var error = (0, _formatApiError2.default)(action, 'Error while loading property analytics');

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    data: null,
    error: error });

};

var handleLoadPropertiesAnalyticsSuccess = function handleLoadPropertiesAnalyticsSuccess(state, action) {return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    data: action.data });};


var handleLoadPropertiesAnalyticsFail = function handleLoadPropertiesAnalyticsFail(state, action) {
  var error = (0, _formatApiError2.default)(action, 'Error while loading property analytics');

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    data: null,
    error: error });

};

var fetchLoadSingeData = function fetchLoadSingeData(params) {return _axiosConfig2.default.get('/properties/daily', { params: params }).
  then(loadSinglePropertyAnalyticsSuccess, loadSinglePropertyAnalyticsFail);};

var sendUserAnalytics = function sendUserAnalytics(_ref) {var userId = _ref.userId,action = _ref.action;return (
    _axiosConfig2.default.post('/users', {
      affected_id: userId,
      action: action }).

    then(sendUserAnalyticsSuccess, sendUserAnalyticsFail));};

var sendPropertiAnalytics = function sendPropertiAnalytics(_ref2) {var affected_id = _ref2.affected_id,action = _ref2.action;return (
    _axiosConfig2.default.post('/properties', {
      affected_id: affected_id,
      action: action }).

    then(sendPropertiesAnalyticsSuccess, sendPropertiesAnalyticsFail));};

var handlePropertiesAnalytics = function handlePropertiesAnalytics(state, params) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true,
    error: null }),
  promise(sendPropertiAnalytics, params));};

var handleSendReferralId = function handleSendReferralId(state, params) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true,
    error: null }),
  promise(sendUserAnalytics, params));};

var handleLoadSinglePropertyAnalytics = function handleLoadSinglePropertyAnalytics(state, params) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true,
    error: null }),
  promise(fetchLoadSingeData, params));};

var handleLoadSinglePropertyAnalyticsSuccess = function handleLoadSinglePropertyAnalyticsSuccess(state, action) {return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    chartData: action.data });};


var handleLoadSinglePropertyAnalyticsFail = function handleLoadSinglePropertyAnalyticsFail(state, action) {
  var error = (0, _formatApiError2.default)(action, 'Error while loading single property analytics');

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    chartData: [],
    error: error });

};

var openChartOfViewsHandler = function openChartOfViewsHandler(state, _ref3) {var publishDate = _ref3.publishDate,propertyViews = _ref3.propertyViews,analyticsAction = _ref3.analyticsAction;return Object.assign({},
  state, {
    publishDate: publishDate,
    propertyViews: propertyViews,
    analyticsAction: analyticsAction,
    isViewsChartOpen: true });};


var closeChartOfViewsHandler = function closeChartOfViewsHandler(state) {return Object.assign({},
  state, {
    publishDate: null,
    propertyViews: null,
    chartData: [],
    isViewsChartOpen: false });};


var propertiesAnalytics = (0, _reduxAct.createReducer)(function (on) {
  on(loadPropertiesAnalytics, handleLoadPropertiesAnalytics);
  on(loadPropertiesAnalyticsSuccess, handleLoadPropertiesAnalyticsSuccess);
  on(loadPropertiesAnalyticsFail, handleLoadPropertiesAnalyticsFail);
  on(loadPropertiesAnalyticsFavoritesSuccess, handleLoadPropertiesAnalyticsFavoritesSuccess);
  on(loadPropertiesAnalyticsFavoritesFail, handleLoadPropertiesAnalyticsFavoritesFail);
  on(loadPropertiesAnalyticsShowNumberSuccess, handleLoadPropertiesAnalyticsShowNumberSuccess);
  on(loadPropertiesAnalyticsShowNumberFail, handleLoadPropertiesAnalyticsShowNumberFail);
  on(loadSinglePropertyAnalytics, handleLoadSinglePropertyAnalytics);
  on(loadSinglePropertyAnalyticsSuccess, handleLoadSinglePropertyAnalyticsSuccess);
  on(loadSinglePropertyAnalyticsFail, handleLoadSinglePropertyAnalyticsFail);
  on(openChartOfViews, openChartOfViewsHandler);
  on(closeChartOfViews, closeChartOfViewsHandler);
  on(sendReferralId, handleSendReferralId);
  on(sendPropertiesAnalytics, handlePropertiesAnalytics);
}, initialState);exports.


loadPropertiesAnalytics = loadPropertiesAnalytics;exports.
loadSinglePropertyAnalytics = loadSinglePropertyAnalytics;exports.
openChartOfViews = openChartOfViews;exports.
closeChartOfViews = closeChartOfViews;exports.
sendReferralId = sendReferralId;exports.
sendPropertiesAnalytics = sendPropertiesAnalytics;exports.default =


propertiesAnalytics;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/propertiesAnalytics.js
// module id = 398
// module chunks = 0